
<template>
    <Feature class="add-subtitles-page">
        
        <template slot="convert_to_text_title">{{$lang.addsubtitles.convert_to_text_title}}</template>
        <template slot="convert_to_text_desc">{{$lang.addsubtitles.convert_to_text_desc}}</template>
        <template slot="start_your_trial">{{$lang.addsubtitles.start_your_trial}}</template>
        <template slot="hero_image">
            <img alt="convert to text banner" :src="hero" width="500">
        </template>

        <!-- unique case -->
        <template slot="additional">
            <Unique>
                <template slot="editing_platform">{{$lang.addsubtitles.unique_title}}</template>
                <template slot="editing_platform_desc0">{{$lang.addsubtitles.unique_desc_1}}</template>
                <template slot="video_trimmed">
                        <div class="video-wrapper" @click="onClicked('video0', true)">
                            <div class="play-button" v-show="!videoState.video0">
                            <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                            </div>
                    <video id="video0" ref="video0" playsinline preload="none" :poster="stepOneImage" class="unique-video" :src="uniqueUrl1" frameborder="0" height="350" width="575" muted></video>
                        </div>
                </template>
                <template slot="editing_platform_desc2">{{$lang.addsubtitles.unique_desc_2}}</template>
                <template slot="video_replace_all">
                    <div class="video-wrapper" @click="onClicked('video2', true)">
                        <div class="play-button" v-show="!videoState.video2">
                            <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                            </div>
                        <video id="video2" ref="video2" playsinline preload="none" :poster="stepTwoImage" class="unique-video" :src="uniqueUrl2" frameborder="0" height="300"  width="575" muted></video>
                    </div>
                </template>
                <template slot="editing_platform_desc3">{{$lang.addsubtitles.unique_desc_3}}</template>
                <template slot="video_add_dictionary">
                    <div class="video-wrapper" @click="onClicked('video3', true)">
                        <div class="play-button" v-show="!videoState.video3">
                            <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                            </div>
                        <video id="video3" ref="video3" playsinline preload="none" :poster="stepThreeImage" class="unique-video" :src="uniqueUrl3" frameborder="0" height="300"  width="575" muted></video>
                    </div>
                </template>
            </Unique>
        </template>

        <!-- Tutorial-->
        <template slot="feature_tutorial_title">{{$lang.addsubtitles.feature_tutorial_title}}</template>
        <template slot="feature_tutorial_desc"><span v-html="$lang.addsubtitles.feature_tutorial_desc">{{$lang.addsubtitles.feature_tutorial_desc}}</span></template>
        <template slot="feature_tutorial_media">
            <div class="play-button" @click="onTutorialClicked" v-show="isHidden">
                  <a class="popup-vimeo animated-circle"><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
           
                </div>
                  <img v-if="isHidden" alt="feature tutorial" :src="tutorialPoster" @click="onTutorialClicked">
            <iframe v-if="!isHidden" width="560" height="315" :src="$lang.addsubtitles.feature_tutorial_youtube" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </template>

        <!-- Extra info-->
        <template slot="feature_extra_title">{{$lang.addsubtitles.feature_extra_title}}</template>
        <template slot="feature_extra_desc">
            <p style="text-align: left;" v-html="$lang.addsubtitles.feature_extra_desc">
                </p>
        </template>
        
    </Feature>
</template>

<script>
import Feature from "./Feature";
import Unique from "@/components/landing/Unique.vue";
const images = require.context('../assets/images/features', true, /\.webp$/)
const videos = require.context('../assets/video', true, /\.mp4$/)

export default {
  data: () => ({
    heroImage: null,
    stepOneImage:'',
    stepTwoImage:'',
    stepThreeImage:'',
    tutorialPoster:'',
    hero:'',
    isHidden:true,
    uniqueUrl1:'',
    uniqueUrl2:'',
    uniqueUrl3:'',

    videoState:{
          video0:false,
          video1:false,
          video2:false,
          video3:false  
      }
  }),
  metaInfo() {
    const me = this;
    return{
      title: me.$lang.addsubtitles.convert_to_text_title_meta,//me.$lang.about.taption,
      titleTemplate: '%s - Taption',
      meta: [
        { vmid: 'name', content: me.$lang.addsubtitles.convert_to_text_title_meta, itemprop: 'name' },
        { vmid: 'description', content: me.$lang.addsubtitles.convert_to_text_desc_meta, itemprop: 'description' },
        { vmid: 'article_desc', content: me.$lang.addsubtitles.convert_to_text_desc_meta, name: 'description' },
        { vmid: 'og_title', content: me.$lang.addsubtitles.convert_to_text_title_meta, property: 'og:title' },
        { vmid: 'og_desc', content: me.$lang.addsubtitles.convert_to_text_desc_meta, property: 'og:description' },
        { vmid:'twitter_title', content: me.$lang.addsubtitles.convert_to_text_title_meta, name: 'twitter:title' },
        { vmid:'twitter_desc',content: me.$lang.addsubtitles.convert_to_text_desc_meta, name: 'twitter:description' },
      ]
    }
  },
  components: {
    Feature,
    Unique
  },
  methods: {
    onTutorialClicked(){
        this.isHidden = false;
    },
    onClicked(videoType, isPlay){
        const me = this;
        me.$refs[videoType].play();
        me.videoState[videoType] = isPlay;
    }
  },
  mounted(){
    const me = this;
    me.stepOneImage = images(me.$lang.addsubtitles.unique_poster_1)
    me.stepTwoImage = images(me.$lang.addsubtitles.unique_poster_2)
    me.stepThreeImage = images(me.$lang.addsubtitles.unique_poster_3)
    me.tutorialPoster = images(me.$lang.addsubtitles.feature_tutorial_poster_url)
    me.hero = images(me.$lang.addsubtitles.hero_img)

    me.uniqueUrl1 = videos(me.$lang.addsubtitles.unique_video_1)
    me.uniqueUrl2 = videos(me.$lang.addsubtitles.unique_video_2)
    me.uniqueUrl3 = videos(me.$lang.addsubtitles.unique_video_3)

    const video0 = document.getElementById("video0");  
    const video1 = document.getElementById("video1");   
    const video2 = document.getElementById("video2");   
    const video3 = document.getElementById("video3");   


    if(video0){
        video0.onended = function() {
            me.videoState.video0 = false;
        }
        // video0.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video0 = false;
        // } 
    }


    if(video1){
        video1.onended = function() {
            me.videoState.video1 = false;
        }
        // video1.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video1 = false;
        // } 
    }


    if(video2){
        video2.onended = function() {
            me.videoState.video2 = false;
        } 
        // video2.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video2 = false;
        // } 
    }

    if(video3){
        video3.onended = function() {
            me.videoState.video3 = false;
        } 
        // video3.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video3 = false;
        // } 
    }
  }
}

</script>

<style>

.add-subtitles-page .unique .unique-container:nth-child(2){
    display:none;
}

.add-subtitles-page .feature-page-three-conatiner{
    display:none;
}



/* .convert-to-text-container{
    background:url(../assets/images/background/add-subtitles-background-1.webp);
    background-size: cover;
}
.additional-container{
    background:url(../assets/images/background/add-subtitles-background-2.webp);
    background-size: cover;
}
.feature-how-to-conatiner{
    background:url(../assets/images/background/add-subtitles-background-3.webp);
    background-size: cover;
}
.feature-why-conatiner{
    background:url(../assets/images/background/add-subtitles-background-4.webp);
    background-size: cover;
} */

</style>
<style scoped>

@media (max-width: 992px) {

  .taption .additional-container section{
    margin:0px!important;
  }
}


</style>


           